<div class="container container-boxed">
  <div class="section-tabs">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
      <mat-tab *ngFor="let section of sortedSections()" [label]="section.data.title">
        <app-section-tab [section]="section"></app-section-tab>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
